/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TaskUpdate/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Assignee from './Assignee/index'
import Board from './Board/index'
import Comment from './Comment/index'
import DueDays from './DueDays/index'
import Priority from './Priority/index'
import React from 'react'
import Stage from './Stage/index'
import Tags from './Tags/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TaskUpdate({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/TaskUpdate"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="TaskUpdate.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z1vjRvn': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="TaskUpdate.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginBottom={dtSpaceXs}
 weight="medium"
 text="Locate task on board"
/>
<Board
  viewPath={`${viewPath}/Board`}
/>
</div>
<div
  data-testid="TaskUpdate.Vertical:1"
  data-view-path={viewPath}
 style={{'--g-2-Z1vjRvn': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Update task"
/>
<div
  data-testid="TaskUpdate.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="TaskUpdate.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Stage"
/>
</div>
<Stage
  viewPath={`${viewPath}/Stage`}
/>
</div>
<div
  data-testid="TaskUpdate.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<div
  data-testid="TaskUpdate.Horizontal:4"
  data-view-path={viewPath}
 style={{'--g-2-Z1vjRvn': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal4}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Due"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 text="(today + days)"
/>
</div>
<DueDays
  viewPath={`${viewPath}/DueDays`}
/>
</div>
<div
  data-testid="TaskUpdate.Horizontal:5"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal5}`}
>
<div
  data-testid="TaskUpdate.Horizontal:6"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal6}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Assignee"
/>
</div>
<Assignee
  viewPath={`${viewPath}/Assignee`}
/>
</div>
<div
  data-testid="TaskUpdate.Horizontal:7"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal7}`}
>
<div
  data-testid="TaskUpdate.Horizontal:8"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal8}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Priority"
/>
</div>
<Priority
  viewPath={`${viewPath}/Priority`}
/>
</div>
<div
  data-testid="TaskUpdate.Horizontal:9"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal9}`}
>
<div
  data-testid="TaskUpdate.Horizontal:10"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal10}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Add tags"
/>
</div>
<Tags
  viewPath={`${viewPath}/Tags`}
/>
</div>
<div
  data-testid="TaskUpdate.Horizontal:11"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal11}`}
>
<div
  data-testid="TaskUpdate.Horizontal:12"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal12}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Comment"
/>
</div>
<Comment
  viewPath={`${viewPath}/Comment`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}